import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  quarterly: false,
  yearly: false,
  live: true,
}

const timeFrameTabOpenSlice = createSlice({
  name: 'timeframeTabOpen',
  initialState,
  reducers: {
    setActiveTimeFrameTab(
      state,
      action: PayloadAction<{
        quarterly: boolean
        yearly: boolean
        live: boolean
      }>
    ) {
      const { quarterly, yearly, live } = action.payload

      state.quarterly = quarterly
      state.yearly = yearly
      state.live = live

      return state
    },
    resetTimeFrameTab(state) {
      return initialState
    },
  },
})

export const { setActiveTimeFrameTab, resetTimeFrameTab } = timeFrameTabOpenSlice.actions
export default timeFrameTabOpenSlice.reducer
